/** 
 *   商户管理 api
 */
import { get, post, put, del } from '@/untils/axios.js'


/*
 *   经营类目
 */

// 分类列表
export const category_list = params => get('shops/category', params)
// 添加分类
export const category_add  = params => post('shops/category', params)
// 修改分类
export const category_put  = (id,params) => put(`shops/category/${id}`, params)
// 删除分类
export const category_del  = id => del(`shops/category/${id}`)



/*
 *   商家入驻
 */

 // 入驻申请列表
export const shops        = (id,params) => get(`shops/list/${id}`, params)

//  商家列表
export const shop_list = params => get('shops/shops-list', params)

 // 获取权限费率
 export const shops_get   = (id,params) => get(`shops/get-setting/${id}`, params)

  // 设置权限费率
  export const shops_set  = (id,params) => post(`shops/set-setting/${id}`, params)

 // 同意 || 驳回 请求
 export const shops_audit = (id,params) => put(`shops/apply-audit/${id}`, params)



 /*
 *   合伙人
 */

 // 入驻申请列表
export const partner = params => get(`agent`, params)

// 同意 || 驳回 请求
export const partner_audit = (id,params) => put(`agent/${id}`, params)

// 合伙人详情
export const partner_detail  = id => get(`agent/${id}`)

// 合伙人钱包记录
export const wallet_log = params => get(`/agent/wallet/detailed`, params)

// 合伙人分享商品用户购买记录
export const bind_user_list = params => get(`/agent/bind/user`, params)

// 合伙人钱包记录
export const bind_user_del = id => del(`/agent/bind/user/${id}`)

// 钱包提现管理列表
export const withdrawal_list = params => get(`/agent/wallet/withdrawal`, params)

// 钱包提现管理  修改状态
export const withdrawal_put = (id, params) => put(`/agent/wallet/withdrawal/${id}`, params)

 /*
 *   商家商品
 */
 // 商品列表
 export const goods   = (id, params) => get(`shops/goods/${id}`, params)

  // 商品详情
  export const detail = (id, params) => get(`shops/goods-details/${id}`, params)
  
  // 商品 修改状态
export const goods_status = (id,params) => put(`goods/${id}`, params)

